// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.toast-container {
  position: fixed;
  top: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9998;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  width: 100%;
  max-width: 420px;
  pointer-events: none;
}

.toast {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.65rem 1rem;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-left: 3px solid var(--gold-main);
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  font-size: 14px;
  animation: toast-in 0.2s ease-out;
}
.toast * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .toast {
    animation: none;
  }
}
.toast--info {
  border-left-color: var(--gold-main);
}
.toast--info .toast__icon {
  color: var(--gold-main);
}
.toast--success {
  border-left-color: #8fbf8a;
}
.toast--success .toast__icon {
  color: #8fbf8a;
}
.toast--warning {
  border-left-color: #e0b45c;
}
.toast--warning .toast__icon {
  color: #e0b45c;
}
.toast--danger {
  border-left-color: #d9786d;
}
.toast--danger .toast__icon {
  color: #d9786d;
}
.toast--gold {
  border-left-color: var(--gold-main);
}
.toast--gold .toast__icon {
  color: var(--gold-main);
}
.toast--quest {
  border-left-color: #7fb4d6;
}
.toast--quest .toast__icon {
  color: #7fb4d6;
}
.toast--level {
  border-left-color: #8fbf8a;
}
.toast--level .toast__icon {
  color: #8fbf8a;
}
.toast__icon {
  flex-shrink: 0;
  color: var(--gold-main);
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.05rem;
}
.toast__icon svg {
  display: block;
  width: 100%;
  height: 100%;
}
.toast__text {
  flex: 1;
  line-height: 1.4;
}

.toast--alert {
  border-left-width: 4px;
  animation: none;
}

.toast-quiet {
  position: fixed;
  left: 1.5rem;
  bottom: 1.5rem;
  z-index: 9996;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  max-width: 340px;
  pointer-events: none;
}
.toast-quiet__item {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.7rem;
  background: rgba(11, 15, 19, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-size: 13px;
  color: #aeaba2;
  animation: toast-quiet-in 0.18s ease-out;
}
.toast-quiet__item * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .toast-quiet__item {
    animation: none;
  }
}
.toast-quiet__icon {
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  color: var(--gold-main);
  display: inline-flex;
}
.toast-quiet__icon svg {
  display: block;
  width: 100%;
  height: 100%;
}
.toast-quiet__item--success .toast-quiet__icon {
  color: #8fbf8a;
}
.toast-quiet__text {
  line-height: 1.35;
}
.toast-quiet__count {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--gold-light);
}

.toast-veil {
  position: fixed;
  inset: 0;
  z-index: 9995;
  pointer-events: none;
  transition: opacity 1.2s ease, background 1.2s ease;
  animation: toast-veil-in 1.2s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .toast-veil {
    animation: none;
    transition: none;
  }
}
.toast-veil--warning {
  background: radial-gradient(ellipse at center, rgba(120, 130, 124, 0) 38%, rgba(120, 130, 124, 0.42) 78%, rgba(104, 114, 108, 0.62) 100%);
}
.toast-veil--danger {
  background: radial-gradient(ellipse at center, rgba(150, 60, 52, 0) 34%, rgba(150, 60, 52, 0.4) 74%, rgba(120, 36, 30, 0.7) 100%);
}

@keyframes toast-quiet-in {
  from {
    opacity: 0;
    transform: translateX(-6px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes toast-veil-in {
  from {
    opacity: 0;
  }
}
@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/toast/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAKA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAHF;;AAMA;EDIE,yDAHU;EAIV,cAbK;ECUL,aAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,kCDnBI;ECoBJ,0CAAA;EACA,uCAAA;EACA,kBDZO;ECaP,yCAAA;EACA,eAAA;EACA,iCAAA;AAFF;ADJE;EAAI,sBAAA;ACON;AACE;EAdF;IAc4C,eAAA;EAG1C;AACF;AADI;EACE,mCA3CS;AA8Cf;AADM;EACE,uBA9CO;AAiDf;AAPI;EACE,0BA3CS;AAoDf;AAPM;EACE,cA9CO;AAuDf;AAbI;EACE,0BA3CS;AA0Df;AAbM;EACE,cA9CO;AA6Df;AAnBI;EACE,0BA3CS;AAgEf;AAnBM;EACE,cA9CO;AAmEf;AAzBI;EACE,mCA3CS;AAsEf;AAzBM;EACE,uBA9CO;AAyEf;AA/BI;EACE,0BA3CS;AA4Ef;AA/BM;EACE,cA9CO;AA+Ef;AArCI;EACE,0BA3CS;AAkFf;AArCM;EACE,cA9CO;AAqFf;AAlCE;EACE,cAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAoCJ;AAlCI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAoCN;AAhCE;EACE,OAAA;EACA,gBAAA;AAkCJ;;AA7BA;EACE,sBAAA;EACA,eAAA;AAgCF;;AA5BA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AA+BF;AA7BE;ED7DA,yDAHU;EAIV,cAbK;EC2EH,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,iCAAA;EACA,0CAAA;EACA,kBD5EK;EC6EL,eAAA;EACA,cDlFK;ECmFL,wCAAA;AAgCJ;ADtGE;EAAI,sBAAA;ACyGN;AAjCI;EAbF;IAa4C,eAAA;EAqC5C;AACF;AAnCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;AAqCJ;AAnCI;EAAM,cAAA;EAAgB,WAAA;EAAa,YAAA;AAwCvC;AArCE;EAA2B,cD/FnB;ACuIV;AAtCE;EACE,iBAAA;AAwCJ;AArCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAuCJ;;AAjCA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,oBAAA;EACA,mDAAA;EACA,sCAAA;AAoCF;AAlCE;EARF;IAQ4C,eAAA;IAAiB,gBAAA;EAuC3D;AACF;AAtCE;EACE,yIAAA;AAwCJ;AArCE;EACE,iIAAA;AAuCJ;;AAnCA;EACE;IAAO,UAAA;IAAY,2BAAA;EAwCnB;EAvCA;IAAO,UAAA;IAAY,wBAAA;EA2CnB;AACF;AAzCA;EACE;IAAO,UAAA;EA4CP;AACF;AA1CA;EACE;IAAO,UAAA;IAAY,2BAAA;EA8CnB;EA7CA;IAAO,UAAA;IAAY,wBAAA;EAiDnB;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Type accent colours. Info and gold follow the palette; the status colours\n// are fixed so a success never turns into the accent.\n$toast-colors: (\n  \"info\": var(--gold-main),\n  \"success\": ink.$success,\n  \"warning\": #e0b45c,\n  \"danger\": ink.$danger,\n  \"gold\": var(--gold-main),\n  \"quest\": #7fb4d6,\n  \"level\": ink.$success,\n);\n\n.toast-container {\n  position: fixed;\n  top: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9998;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.5rem;\n  width: 100%;\n  max-width: 420px;\n  pointer-events: none;\n}\n\n.toast {\n  @include ink.base;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.65rem 1rem;\n  background: ink.$ink;\n  border: 1px solid ink.$line-strong;\n  border-left: 3px solid var(--gold-main);\n  border-radius: ink.$radius;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  font-size: 14px;\n  animation: toast-in 0.2s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n\n  @each $type, $color in $toast-colors {\n    &--#{$type} {\n      border-left-color: $color;\n\n      .toast__icon {\n        color: $color;\n      }\n    }\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    color: var(--gold-main);\n    width: 1.2rem;\n    height: 1.2rem;\n    margin-top: 0.05rem;\n\n    svg {\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__text {\n    flex: 1;\n    line-height: 1.4;\n  }\n}\n\n// Persistent alert: the same card, but it holds still and carries a bolder edge\n.toast--alert {\n  border-left-width: 4px;\n  animation: none;\n}\n\n// Quiet level: small and translucent, bottom left, never takes the eye off the game\n.toast-quiet {\n  position: fixed;\n  left: 1.5rem;\n  bottom: 1.5rem;\n  z-index: 9996;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.35rem;\n  max-width: 340px;\n  pointer-events: none;\n\n  &__item {\n    @include ink.base;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.35rem 0.7rem;\n    background: rgba(11, 15, 19, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: ink.$radius;\n    font-size: 13px;\n    color: ink.$text-2;\n    animation: toast-quiet-in 0.18s ease-out;\n\n    @media (prefers-reduced-motion: reduce) { animation: none; }\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    width: 1rem;\n    height: 1rem;\n    color: var(--gold-main);\n    display: inline-flex;\n\n    svg { display: block; width: 100%; height: 100%; }\n  }\n\n  &__item--success &__icon { color: ink.$success; }\n\n  &__text {\n    line-height: 1.35;\n  }\n\n  &__count {\n    flex-shrink: 0;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--gold-light);\n  }\n}\n\n// The edges of the screen, tinted while a persistent alert lasts. Grey while it only warns, red once it\n// hurts; the opacity (set inline) follows the intensity the server reports.\n.toast-veil {\n  position: fixed;\n  inset: 0;\n  z-index: 9995;\n  pointer-events: none;\n  transition: opacity 1.2s ease, background 1.2s ease;\n  animation: toast-veil-in 1.2s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; transition: none; }\n\n  &--warning {\n    background: radial-gradient(ellipse at center, rgba(120, 130, 124, 0) 38%, rgba(120, 130, 124, 0.42) 78%, rgba(104, 114, 108, 0.62) 100%);\n  }\n\n  &--danger {\n    background: radial-gradient(ellipse at center, rgba(150, 60, 52, 0) 34%, rgba(150, 60, 52, 0.4) 74%, rgba(120, 36, 30, 0.7) 100%);\n  }\n}\n\n@keyframes toast-quiet-in {\n  from { opacity: 0; transform: translateX(-6px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes toast-veil-in {\n  from { opacity: 0; }\n}\n\n@keyframes toast-in {\n  from { opacity: 0; transform: translateY(-8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
